module.exports = __webpack_public_path__ + "static/img/bd2da1bfca707570e9371f533b6a440d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MODE3-on.png
// module id = CJ/C
// module chunks = 1